import { configureStore } from "@reduxjs/toolkit";

import authSlice from "./auth-slice";
import driversSlice from "./drivers-slice";
import vehiclesSlice from "./vehicles-slice";
import bookingsSlice from "./bookings-slice";
import timeslotsSlice from "./timeslots-slice";
import optionsSlice from "./options-slice";
import userSlice from "./user-slice";

const store = configureStore({
  reducer: {
    auth: authSlice,
    drivers: driversSlice,
    vehicles: vehiclesSlice,
    bookings: bookingsSlice,
    timeslots: timeslotsSlice,
    options: optionsSlice,
    user: userSlice,
  },
});

export default store;
